<template>
  <v-container id="project-list">
    <v-row>
      <v-col cols="8" md="8" class="breadcrumbs">
        <v-breadcrumbs :items="breadcrumbs" :large="true" :divider="'>'">
        </v-breadcrumbs>
      </v-col>

      <v-col cols="4" sm="4">
        <div class="text-right">
          <div cols="10" md="1">
            <app-modal-insert-project
              :edit="false"
              :color="'success'"
              :icon="'mdi-plus-circle'"
              @on-save="loadProjects"
            >
              <template
                v-slot:title
                :edit="false"
                :color="'success'"
                :icon="'mdi-plus-circle'"
              >
                Cadastrar Projeto
              </template>
            </app-modal-insert-project>
          </div>
        </div>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="projects"
          item-key="name"
          class="elevation-1"
          :loading="loading"
          loading-text="Carregando ..."
        >
          <template v-slot:item.acoes="{ item }">
            <v-row>
              <v-col cols="2">
                <app-modal-insert-project
                  :object="item"
                  :edit="true"
                  :color="'warning'"
                  :icon="'mdi-pencil'"
                  @onSave="loadProjects()"
                >
                  <template v-slot:title> Edição de Projeto </template>
                </app-modal-insert-project>
              </v-col>
            </v-row>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { projectAPI } from "./ProjectAPI";
import AppModalInsertProject from "./ModalInsert";
// import AppModalDeleteProject from './ModalDelete'
import { mapActions, mapGetters } from "vuex";

export default {
  name: "AppProjectList",
  components: {
    AppModalInsertProject,
    // AppModalDeleteProject
  },
  data() {
    return {
      headers: [
        {
          text: "#",
          value: "projetoId",
          sortable: false,
        },
        {
          text: "Nome",
          align: "left",
          value: "nome",
        },
        {
          text: "Descricao",
          value: "descricao",
        },
        {
          text: "Ações",
          value: "acoes",
          sortable: false,
        },
      ],
      projects: [],
      breadcrumbs: [
        {
          text: "Home",
          disabled: false,
          href: "cidade",
        },
        {
          text: "Gestão de Projetos",
          disabled: true,
          href: "projeto",
        },
      ],
    };
  },
  mounted() {
    this.loadProjects();
  },
  computed: {
    ...mapGetters(["loading"]),
  },
  methods: {
    ...mapActions(["setLoading"]),
    loadProjects() {
      this.setLoading(true);
      projectAPI
        .list()
        .then((resp) => {
          this.projects = resp.data;
          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao listar projetos");
        });
    },
  },
};
</script>

<style lang="scss">
@import "./style.scss";
</style>
